import { render, staticRenderFns } from "./commonTerms.vue?vue&type=template&id=52129894&scoped=true&"
import script from "./commonTerms.vue?vue&type=script&lang=js&"
export * from "./commonTerms.vue?vue&type=script&lang=js&"
import style0 from "./commonTerms.vue?vue&type=style&index=0&id=52129894&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52129894",
  null
  
)

export default component.exports